import api from "../index";

export const GetPromotionKitApi = (params) => api.get(`PromotionKit/GetAll-PromotionKit?${params}`);
export const PromotionKitStatusChangeApi = (data) => api.patch(`PromotionKit/UpdateStatus-PromotionKit`, data);
export const AddUpdatePromotionKitApi = (data, headers) => api.post('PromotionKit/AddUpdate-PromotionKit', data, headers);
export const DeleteKitsApi = (kitsId) => api.delete(`PromotionKit/Delete-PromotionKit?Id=${kitsId}`);